// ---------------------------------------------
// ---------------------------------------------
// -------------- Google Recapcha --------------
// ---------------------------------------------
// ---------------------------------------------
function setAttributGoogle() {
      // document.querySelector(".g-recaptcha").setAttribute("data-sitekey", window.SitePreferences.CAPTCHAV2_API_KEY);
      document.querySelector(".g-recaptcha").setAttribute("data-sitekey", "12312412442141");


      // Create a new script element
      var scriptElement = document.createElement("script");
      // Set the src attribute
      scriptElement.src = "https://www.google.com/recaptcha/api.js";
      // Add async and defer attributes
      // scriptElement.async = true;
      // scriptElement.defer = true;
      // Append the script element to the document body (or head)
      document.querySelector(".fixed-element").appendChild(scriptElement);
}

function recapchaInit() {
      // window.SitePreferences === undefined ? setTimeout(recapchaInit, 2000) : setAttributGoogle();
      setAttributGoogle();
}

recapchaInit(); // Démarre la boucle

// ---------------------------------------------
// ---------------------------------------------
// -------------- Popin --------------
// ---------------------------------------------
// ---------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
      const fixedElement = document.getElementById('fixedElement');
      const emailInput = document.getElementById('emailInput');
      const subscribeButton = document.getElementById('subscribeButton');
      const errorMessage = document.getElementById('errorMessage');
      const closeButton = document.getElementById('closeButton');
      const title = document.getElementById('smallText')


      // Function to create a cookie
      function setCookieNews(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
      }

      // Function to get a cookie
      function getCookieNews(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                  let c = ca[i];
                  while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                  if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
      }

      function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
      }

      // Check if the cookie exists
      if (getCookieNews('newsletterClosed')) {
            fixedElement.style.display = 'none';
      } else {
            // Add visible class after a short delay to trigger animation
            setTimeout(() => {
                  fixedElement.classList.add('visible');
            }, 100);

            fixedElement.addEventListener('click', () => {
                  if (!fixedElement.classList.contains('expanded')) {
                        fixedElement.classList.add('expanded');
                        title.style.display = "none";
                  }
            });

            closeButton.addEventListener('click', (event) => {
                  event.stopPropagation();
                  fixedElement.style.display = 'none';
                  setCookieNews('newsletterClosed', 'true', 1); // Cookie valid for 1 day
            });

            subscribeButton.addEventListener('click', (event) => {
                  event.preventDefault();
                  let email = emailInput.value;

                  console.log(validateEmail(email));

                  if (validateEmail(email)) {

                        var formData = new FormData();
                        formData.append("newsletter_email", email);
                        formData.append("tokenCaptchaV2", grecaptcha.getResponse());
                        fetch("/on/demandware.store/Sites-ETAM_UK-Site/en_GB/Newsletter-Subscribe", {
                              method: "POST",
                              body: formData,
                        }).then(response => response.json()).then(res => {
                              console.log(res.success)
                              if (res.success) {
                                    errorMessage.textContent = "Thank you for subscribing!";
                                    errorMessage.style.color = "green";
                                    errorMessage.style.display = "block";
                              }
                        });

                        // Here you can add your subscription logic, like an API call.
                  } else {
                        errorMessage.textContent = "Please enter a valid email address.";
                        errorMessage.style.color = "red";
                        errorMessage.style.display = "block";
                  }
            });
      }

      // Add visible class after a short delay to trigger animation
      setTimeout(() => {
            fixedElement.classList.add('visible');
      }, 1000);
});
